import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import {
  AutomaticResendDto,
  CreateAutomaticResendCommand,
  DeliveryStatus,
  UpdateAutomaticResendCommand,
} from 'src/app/core/api/models';
import { AutomaticResendsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { PrivateNumbersChipListSelectSearchComponent } from "../../../../shared/components/chip-list-select-search/private-numbers-chip-list-select-search.component";


@Component({
    selector: 'app-automatic-resend-form',
    templateUrl: './automatic-resend-form.component.html',
    imports: [BaseFormModule, PrivateNumbersChipListSelectSearchComponent]
})
export class AutomaticResendFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  formPageConfig: FormPageConfig<any> = {};

  model: AutomaticResendDto = {};

  get DeliveryStatus() {
    return DeliveryStatus;
  }

  //#endregion

  constructor(protected currentService: AutomaticResendsService) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.disableControls();
  }

  //#region init methods

  initForm() {
    this.form = new FormGroup({
      privateNumberId: new FormControl('', Validators.required),
      deliveryStatus: new FormControl('', Validators.required),
      organizationId: new FormControl('', Validators.required),
      organizationName: new FormControl(''),
      deliveryStatusTitle: new FormControl(''),
      targetPrivateNumbers: new FormControl(''),
    });
  }

  disableControls() {
    try {
      if (this.formPageConfig.isEditMode) {
        this.form.controls['organizationName'].disable();
        this.form.controls['deliveryStatusTitle'].disable();

        this.form.get('organizationId').clearValidators();
        this.form.get('organizationId').updateValueAndValidity();
      }
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.systemManagement
      );
    }
  }
  //#region Api

  //Create
  baseCreateApi(model: CreateAutomaticResendCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .automaticResendsCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  //Update
  baseUpdateApi(model: UpdateAutomaticResendCommand) {
    this.unSubs();

    this.loading = true;

    this.currentService
      .automaticResendsUpdatePut({ id: model.id.toString(), body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  emptyTargetPrivateNumbers() {
    this.model.targetPrivateNumbers = [];
  }
}
